// Дерево групп товаров: узлы { key, title, group, children }, сортировка по имени.
// Группа с несуществующим родителем считается корневой, циклы отбрасываются.
export function buildGroupTree(groups) {
    const ids = new Set(groups.map((g) => g.id));
    const byParent = new Map();
    groups.forEach((g) => {
        const parent = g.parentId != null && ids.has(g.parentId) ? g.parentId : null;
        if (!byParent.has(parent)) byParent.set(parent, []);
        byParent.get(parent).push(g);
    });
    const make = (parent, path) => (byParent.get(parent) ?? [])
        .filter((g) => !path.has(g.id))
        .sort((a, b) => a.name.localeCompare(b.name, 'ru'))
        .map((g) => {
            const children = make(g.id, new Set(path).add(g.id));
            return { key: g.id, title: g.name, group: g, children: children.length ? children : undefined };
        });
    return make(null, new Set());
}

// Группа и все её подгруппы
export function descendantIds(groups, id) {
    const result = new Set([id]);
    const queue = [id];
    while (queue.length) {
        const parent = queue.shift();
        groups.forEach((g) => {
            if (g.parentId === parent && !result.has(g.id)) {
                result.add(g.id);
                queue.push(g.id);
            }
        });
    }
    return result;
}

// Количество товаров в группе вместе с подгруппами: Map<groupId, count>
export function countByGroup(tree, products) {
    const direct = new Map();
    products.forEach((p) => {
        if (p.groupId != null) direct.set(p.groupId, (direct.get(p.groupId) ?? 0) + 1);
    });
    const result = new Map();
    const walk = (nodes) => nodes.reduce((sum, n) => {
        const total = (direct.get(n.key) ?? 0) + walk(n.children ?? []);
        result.set(n.key, total);
        return sum + total;
    }, 0);
    walk(tree);
    return result;
}

// Дерево для TreeSelect: { value, title, children }
export function toSelectTree(tree) {
    return tree.map((n) => ({ value: n.key, title: n.title, children: n.children ? toSelectTree(n.children) : undefined }));
}
